import React, { useEffect } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import '../styles/WaitingRoom.css';
import fr from '../locales/fr';
import en from '../locales/en';
import image1 from '../img/prop1.png';
import image2 from '../img/prop2.png';
import image3 from '../img/prop3.png';
import image4 from '../img/prop4.png';
import image5 from '../img/prop5.png';
import image6 from '../img/prop6.png';
import image7 from '../img/prop7.png';
import image8 from '../img/prop8.png';
import image9 from '../img/prop9.png';
import image10 from '../img/prop10.png';
import image11 from '../img/prop11.png';
import image12 from '../img/prop12.png';
import image13 from '../img/prop13.png';
import image14 from '../img/prop14.png';
import image15 from '../img/prop15.png';
import image16 from '../img/prop16.png';
import image17 from '../img/prop17.png';
import image18 from '../img/prop18.png';

function OnTv({ ws }) {
  const navigate = useNavigate();
  const location = useLocation();
  const browserLang = navigator.language || navigator.userLanguage;
  const language = browserLang.startsWith('fr') ? 'fr' : 'en';
  const translations = language === 'fr' ? fr : en;

  const allowed =
    location.state?.fromAuthorized ||
    sessionStorage.getItem('canAccessOnTV');

  document.cookie = 'playerResponses=; expires=Thu, 05 Oct 2000 00:00:00 UTC; path=/;';

  useEffect(() => {


    const generateImages = () => {
      const numberOfImages = 5;
      const container = document.querySelector('.container');
      if (!container) return;

      const images = [
        image1, image2, image3, image4, image5, image6, image7, image8, image9,
        image10, image11, image12, image13, image14, image15, image16, image17, image18
      ];

      for (let i = 0; i < numberOfImages; i++) {
        const image = document.createElement('img');
        const randomImageIndex = Math.floor(Math.random() * images.length);
        const randomSize = Math.random() * 50 + 30;
        const randomX = Math.random() * (window.innerWidth - randomSize);
        const randomAnimationDuration = Math.random() * 5 + 2;

        image.setAttribute('src', images[randomImageIndex]);
        image.classList.add('rain-image');
        image.style.width = `${randomSize}px`;
        image.style.position = 'absolute';
        image.style.left = `${randomX}px`;
        image.style.top = `-${randomSize}px`;
        image.style.animationDuration = `${randomAnimationDuration}s`;
        image.style.transition = `top ${randomAnimationDuration}s linear`;

        container.appendChild(image);

        setTimeout(() => {
          image.style.top = `${window.innerHeight}px`;
        }, 0);
      }
      container.addEventListener('transitionend', handleTransitionEnd);
    };

    const handleTransitionEnd = (event) => {
      const container = document.querySelector('.container');
      const image = event.target;

      if (container.contains(image)) {
        container.removeChild(image);
      }
    };

    const handleWebSocketMessage = (event) => {
      const message = event.data;
      const ROOM = localStorage.getItem('UNITY');

      switch (message) {
        case ROOM + ":ANSWER":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessAnswer', 'true');
          navigate("/answer", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":WAIT":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessWaitingState', 'true');
          navigate("/waitingState", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":CLOSE":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessRestart', 'true');
          navigate("/restart", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":VOTE":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessExportVote', 'true');
          navigate("/exportVote", { state: { fromAuthorized: true } });
          break;
        default:
          console.log("Message non reconnu:", message);
      }
    };

    ws.onmessage = handleWebSocketMessage;

    generateImages();
    const interval = setInterval(generateImages, 2500);
    return () => {
      clearInterval(interval);
      ws.onmessage = null;
    };
  }, [ws, navigate]);

  useEffect(() => {
    if (allowed) {
      sessionStorage.removeItem('canAccessOnTV');
    }
  }, [allowed]);

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="container">
      <h1 className="title">{translations.onTV.title}</h1>
      <div className="loader"></div>
    </div>
  );
}

export default OnTv;
